var formHelpers = require('clutch/formErrors');
var createErrorNotification = require('base/components/errorNotification');

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
}

$(document).ready(function () {
    $('form.gc-order-form').on('submit', function (event) {
        event.preventDefault();
        var $form = $(this);
        var url = $form.attr('action');

        $form.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: $form.serialize(),
            success: function (response) {
                $form.spinner().stop();

                formHelpers.clearPreviousErrors($form);
                if (response.error) {
                    if (response.fieldErrors && response.fieldErrors.length) {
                        response.fieldErrors.forEach(function (error) {
                            if (Object.keys(error).length) {
                                formHelpers.loadFormErrors($form, error);
                            }
                        });
                    }
                }

                handlePostCartAdd(response);
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                }

                $form.spinner().stop();
            }
        });
    });
});
